export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6792.6b270485.jpg";